/**
 * 官网待填写信息集中配置
 *
 * 上线前把下面所有「待填写」项替换为真实信息即可，页面里不再散落占位符。
 * 这些值与语言无关（公司名、注册号、邮箱、电话等在三语下展示同一份）。
 *
 * 对应早期单页官网 index.html 头部的替换清单：
 *   COMPANY_FULL_NAME / COMPANY_REG_NO / COMPANY_ADDRESS / COMPANY_FOUND_DATE /
 *   ICP_NO / DOMAIN / SUPPORT_EMAIL / SUPPORT_PHONE / SUPPORT_WHATSAPP /
 *   SUPPORT_HOURS / PRIVACY_EMAIL / CURRENCY / PAY_CHANNELS / EFFECTIVE_DATE
 *
 * 注：APK / 应用市场下载地址不在这里 —— 官网所有下载按钮都导向下载页（download.html），
 * 真实下载地址统一由 build/env.js 的 RUNTIME_SHARED.download 提供（download 页读取）。
 */

/** 下载页（同工程的 download 页，构建产物为 download.html） */
export const DOWNLOAD_PAGE_URL = "./download.html"

export interface SiteInfo {
  /** 运营主体法定全称 */
  companyName: string
  /** 营业执照 / 商业注册号 */
  regNo: string
  /** 注册 / 办公地址 */
  address: string
  /** 成立日期 */
  foundDate: string
  /** 官网正式域名 */
  domain: string
  /** 网站备案号 / 许可证编号 */
  licenseNo: string
  /** 客服邮箱（建议 support@ 域名邮箱） */
  supportEmail: string
  /** 公司电话 */
  companyPhone: string
  /** WhatsApp / Telegram 等在线客服 */
  supportOnline: string
  /** 在线客服链接 */
  supportOnlineUrl: string
  /** 客服工作时间（含时区） */
  supportHours: string
  /** 隐私保护专用邮箱（建议 privacy@） */
  privacyEmail: string
  /** 结算币种，如 USD / KHR */
  currency: string
  /** 已接入的支付渠道清单 */
  payChannels: string
  /** 常规订单发货时效（工作日） */
  shipDays: string
  /** 配送覆盖地区 */
  serviceArea: string
  /** 已签收订单的售后申请时限（天） */
  returnDays: string
  /** 争议受理时效（工作日） */
  disputeDays: string
  /** 条款重大变更提前通知天数 */
  termsNoticeDays: string
  /** 邮件响应时效（工作日） */
  responseDays: string
  /** 政策生效 / 最后更新日期 */
  effectiveDate: string
}

export const SITE: SiteInfo = {
  companyName: "KHMER AI NOVA Co .,LTD",
  regNo: "【待填写：COMPANY_REG_NO】",
  address:
    "street financial # s8-22 ,sangkat velal vong ,khan7 makara,Phnom Penh.",
  foundDate: "【待填写：COMPANY_FOUND_DATE】",
  domain: "【待填写：DOMAIN】",
  licenseNo: "【待填写：ICP_NO】",
  supportEmail: "khsusucareimportexport@gmail.com",
  companyPhone: "855 017521521",
  supportOnline: "@Kimhouth1168",
  supportOnlineUrl: "https://t.me/Kimhouth1168",
  supportHours: "【待填写：SUPPORT_HOURS，例：周一至周日 09:00–18:00 (GMT+7)】",
  privacyEmail: "khsusucareimportexport@gmail.com",
  currency: "【待填写：CURRENCY】",
  payChannels:
    "【待填写：PAY_CHANNELS — 例如 XX 支付 / XX 银行 KHQR / XX 钱包】",
  shipDays: "7",
  serviceArea: "【待填写：服务地区，如柬埔寨金边市及周边】",
  returnDays: "7",
  disputeDays: "7",
  termsNoticeDays: "7",
  responseDays: "7",
  effectiveDate: "2026/09/30",
}

/** 锚点 id 与页面区块一一对应，导航与页脚共用 */
export const ANCHORS = {
  model: "model",
  payment: "payment",
  refund: "refund",
  dispute: "dispute",
  terms: "terms",
  privacy: "privacy",
  thirdParty: "third-party",
  safety: "safety",
  faq: "faq",
  contact: "contact",
  download: "download",
} as const
